<h1 mat-dialog-title i18n="@@app.help.risk.example">Ejemplo</h1>
<div mat-dialog-content [ngClass]="{ noData: withExample === false }">
  @if (withExample) {
    <div>
      {{ example }}
    </div>
  } @else {
    <span i18n="@@app.help.risk.noExample">No se ha facilitado ningún ejemplo</span>
  }
  <ng-template #noData i18n="@@app.help.risk.noExample">No se ha facilitado ningún ejemplo</ng-template>
</div>
<div mat-dialog-actions class="btn-container flex f-ai--center f-jc--center">
  <button mat-raised-button mat-dialog-close i18n="@@app.help.risk.close">Cerrar</button>
</div>
